module.exports = __webpack_public_path__ + "static/ayomide-479be213184f8d81eee849d4c1ea210b.png";